
export default function TechnologySection() {
  const features = [
    {
      icon: 'ri-eye-line',
      title: 'Detecção de Público em Tempo Real',
      description: 'Identificação de pessoas, gênero e idade com total anonimato e privacidade garantida.',
      gradient: 'from-blue-500 to-cyan-500'
    },
    {
      icon: 'ri-focus-3-line',
      title: 'Medição de Engajamento Ocular',
      description: 'Verificação precisa se o anúncio foi realmente visto e por quanto tempo.',
      gradient: 'from-purple-500 to-pink-500'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Relatórios Inteligentes',
      description: 'Dados acionáveis que comprovam impacto real e retorno sobre investimento.',
      gradient: 'from-green-500 to-teal-500'
    }
  ];

  return (
    <section id="tecnologia" className="py-20 bg-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-500 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-500 rounded-full filter blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Como Funciona a <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">Tecnologia</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Nossa plataforma de IA revoluciona a forma como as marcas se conectam com seu público
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700 hover:border-gray-600 transition-all duration-300 transform hover:scale-105"
            >
              <div className={`w-16 h-16 bg-gradient-to-r ${feature.gradient} rounded-2xl flex items-center justify-center mb-6`}>
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-4">{feature.title}</h3>
              <p className="text-gray-300 leading-relaxed">{feature.description}</p>
              
              <div className="mt-6 pt-6 border-t border-gray-700">
                <div className="flex items-center text-sm text-gray-400">
                  <i className="ri-shield-check-line mr-2"></i>
                  100% Privacidade Garantida
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-blue-600/20 to-purple-600/20 rounded-2xl p-8 border border-blue-500/30">
            <h3 className="text-2xl font-bold text-white mb-4">Tecnologia Patenteada</h3>
            <p className="text-gray-300 text-lg">
              Nossa IA proprietária processa milhões de dados em tempo real, garantindo precisão e confiabilidade únicas no mercado.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
